export enum UserRequestActionsTypes {
    ALL= 'ALL',
    APPROVE = 'APPROVE',
    MY_ITEMS = 'MY_ITEMS'
}